import { ImportRequestStatus } from './enums'

export const IMPORT_REQUEST_STATUS_LABELS: Record<ImportRequestStatus, string> = {
  [ImportRequestStatus.PendingUpload]: 'Pending upload',
  [ImportRequestStatus.Scanning]: 'Scanning',
  [ImportRequestStatus.PendingVerification]: 'Pending',
  [ImportRequestStatus.Processing]: 'Processing',
  [ImportRequestStatus.Approved]: 'Approved',
  [ImportRequestStatus.Rejected]: 'Rejected',
  [ImportRequestStatus.Failed]: 'Failed',
  [ImportRequestStatus.CopyingExternalCloudLocation]: 'Copying source',
  [ImportRequestStatus.Pending]: 'Pending review',
  [ImportRequestStatus.CopyingToAirlockInBucket]: 'Releasing',
  [ImportRequestStatus.Available]: 'Available'
}

export const getImportRequestStatusLabel = (status: ImportRequestStatus): string =>
  IMPORT_REQUEST_STATUS_LABELS[status] ?? status
